<script setup>
import ApiServices from "@/Services/ApiServices"
import InspectionReports from "@/components/InspectionReports.vue";
import { ref, onMounted } from "vue"

const props = defineProps({ nid: { required: true } })

const project = ref(null)
const encodedAddress = ref("")
const cleanAddress = ref("")
const loading = ref(true)
const loadError = ref(null)

onMounted(async () => {
  try {
    const { data } = await ApiServices.getProject(props.nid)

    // If you ever hit the old View accidentally, normalize it:
    const p = Array.isArray(data) ? data[0] : data

    project.value = p || {}
    // console.log("Project payload:", project.value)

    // New payload: `address` already flattened in the controller
    const addr = project.value.address
        || ""

    cleanAddress.value = addr
    encodedAddress.value = encodeURIComponent(addr)
  } catch (e) {
    console.error("[ProjectDetails] load failed:", e)
    loadError.value = e?.message || "Failed to load project"
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <v-main>
    <v-container>
      <!-- Loader -->
      <v-row v-if="loading" justify="center">
        <v-col cols="12" class="text-center">
          <v-skeleton-loader type="article" />
        </v-col>
      </v-row>

      <!-- Error -->
      <v-alert v-else-if="loadError" type="error" prominent>
        {{ loadError }}
      </v-alert>

      <!-- Project Details -->
      <v-row v-else>
        <v-col cols="12" md="8" class="mx-auto">
          <v-card class="pa-4" elevation="2">
            <h2 class="text-h5 mb-2">{{ project.title }}</h2>
<!--            <p class="mb-4 text-grey">-->
<!--              {{ project.type }} | {{ project.callSign }} | Stage: {{ project.stage }}-->
<!--            </p>-->
            <!-- Address -->
            <a
                v-if="project.address"
                :href="`https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=${encodeURIComponent(project.address)}`"
                target="_blank"
                rel="noopener"
                class="text-decoration-none d-inline-flex align-center my-1"
            >
              <f-a-i
                  icon="location-dot"
                  class="mr-2 text-primary"
                  style="font-size: 1.1rem;"
              />
              <span class="text-secondary">{{ project.address }}</span>
            </a>
            <!-- Owner info -->
            <v-divider class="my-3" />
<!--            <h3 class="text-h6 mb-1">Owner</h3>-->
            <p class="mb-0">
              <strong>{{ project.informal_name }}</strong><br />

              <!-- Email -->
              <a v-if="project.email"
                  :href="`mailto:${project.email}`"
                  class="text-decoration-none d-inline-flex align-center my-1">
                <f-a-i icon="envelope" class="mr-2 text-primary" style="font-size: 1.1rem;"/>
                <span class="text-secondary">{{ project.email }}</span>
              </a><br />

              <!-- Phone -->
              <a v-if="project.phone"
                 :href="`tel:${project.phone.replace(/\\s+/g, '')}`"
                 class="text-decoration-none d-inline-flex align-center my-1">
                <f-a-i icon="phone" class="mr-2 text-primary" style="font-size: 1.1rem;"/>
                <span class="text-secondary">{{ project.phone }}</span>
              </a><br />

              <!-- Mobile -->
              <a  v-if="project.mobile"
                  :href="`tel:${project.mobile.replace(/\\s+/g, '')}`"
                  class="text-decoration-none d-inline-flex align-center my-1"
              >
                <f-a-i
                    icon="mobile-screen"
                    class="mr-2 text-primary"
                    style="font-size: 1.1rem;"
                />
                <span class="text-secondary">{{ project.mobile }}</span>
              </a>
            </p>
            <!-- Reports -->
            <v-divider class="my-3" />
            <inspection-reports :nid="project.nid" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>


<style scoped>

.white-line {
  color: white;
}
  .icon {
    color: black;
    margin-right: 10px;
  }
  .icon-gray {
    color: darkgray;
    transform: scale(0.7)
  }
  .user-details-wrapper {
    background-color: #ddd;
    padding: 10px 10px;
  }
  .user-details {
    a {
      color: black;
      text-decoration: none;
      //font-weight: lighter;
    }
    a:hover {
      transform: scale(1.2);
      border: 1px solid whitesmoke;
    }
    a:visited {
      color: black;
    }
    font-size: larger;
  }
  .orange {
    color: #f57c00;
  }
</style>